import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppleAuth, KakaoAuth, NaverAuth } from "src/common/auth/socialAuth";

export const LoginPage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);
  const navi = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 480);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleKakaoLogin = async () => {
    try {
      // KakaoAuth 유틸리티 사용
      KakaoAuth.login();
    } catch (error) {
      console.error("카카오 로그인 오류:", error);
      // 오류 처리
      alert("카카오 로그인 중 오류가 발생했습니다. 다시 시도해주세요.");
    }
  };

  const handleNaverLogin = () => {
    try {
      // NaverAuth 유틸리티 사용
      NaverAuth.login();
    } catch (error) {
      console.error("네이버 로그인 오류:", error);
      // 오류 처리
      alert("네이버 로그인 중 오류가 발생했습니다. 다시 시도해주세요.");
    }
  };

  // 게스트 로그인
  // const guestLogin = useMutation({
  //   mutationFn: () =>
  //     request<BaseResponse>({
  //       method: "POST",
  //       url: `/auth/login`,
  //       data: loginDto,
  //     }),
  //   onSuccess: async (res: any) => {
  //     if (res.response.accessToken) writeAccessToken(res.response.accessToken);
  //     if (res.response.refreshToken)
  //       writeRefreshToken(res.response.refreshToken);
  //     if (res.response.user) setUser(res.response.user);

  //     navi("/");
  //   },
  // });

  // const handleGuestLogin = () => {
  //   try {
  //     GuestAuth.login(() => guestLogin.mutate());
  //   } catch (error) {
  //     console.error("게스트 로그인 오류:", error);
  //     // 오류 처리
  //     alert("게스트 로그인 중 오류가 발생했습니다. 다시 시도해주세요.");
  //   }
  // };

  const handleAppleLogin = () => {
    try {
      // AppleAuth 유틸리티 사용
      AppleAuth.login();
    } catch (error) {
      console.error("애플 로그인 오류:", error);
      // 오류 처리
      alert("애플 로그인 중 오류가 발생했습니다. 다시 시도해주세요.");
    }
  };

  // const handleGoogleLogin = () => {
  //   console.log("구글 로그인");
  // };

  /* 로그인 오류 Alert 3개 */
  //   showAlert(
  //     "계정연결이 불가능합니다.\n다른 소셜로 로그인해주세요.",
  //     {
  //       title: "계정연결오류",
  //       options: { buttonText: "닫기" },
  //     }
  //   )
  //   showAlert(
  //     "네트워크가 연결되어있지 않은 것 같아요.\n 확인 후 다시 시도해주세요.",
  //     {
  //       title: "인터넷 연결을 확인해주세요.",
  //       options: { buttonText: "나가기" },
  //     }
  //   )
  //   showAlert(
  //     "불편을 드려 죄송합니다. 일시적인 오류로 접속이 불가하오니, 잠시 후 다시 접속해주세요.",
  //     {
  //       title: "시스템 오류",
  //       options: { buttonText: "나가기" },
  //     }
  //   )
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        maxHeight: "100vh",
        maxWidth: "45rem",
        margin: "0 auto",
        position: "relative",
        background: "#F7F7F7",
        overflow: "hidden",
        padding: "115px 16px 36px",
        boxSizing: "border-box",
      }}
    >
      {/* 로고 */}
      <div
        style={{
          // width: "100%",
          height: "100%",
          position: "relative",
        }}
      >
        <div>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_987_41863)">
              <path
                d="M0 5.37815C0 2.40788 2.40788 0 5.37815 0H16C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16V5.37815Z"
                fill="#FAAE1D"
              />
            </g>
            <circle cx="13.5313" cy="12.3887" r="0.96" fill="#404040" />
            <circle cx="21.5313" cy="12.3887" r="0.96" fill="#404040" />
            <path
              d="M18.7408 14.4857C18.3308 15.2968 17.2779 15.4381 16.746 14.6494C16.4984 14.2811 15.9 14.6308 16.1512 14.9991C16.9528 16.1859 18.6743 16.145 19.3393 14.8354C19.5425 14.4373 18.944 14.0839 18.7445 14.4857H18.7408Z"
              fill="#404040"
            />
            <path
              d="M10.5353 3.35246C8.21742 4.13858 6.02363 5.87666 4.58854 8.48397"
              stroke="#FBD984"
              strokeOpacity="0.7"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <defs>
              <filter
                id="filter0_i_987_41863"
                x="0"
                y="0"
                width="32"
                height="34"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 0.929412 0 0 0 0 0.839216 0 0 0 0.41 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_987_41863"
                />
              </filter>
            </defs>
          </svg>
        </div>

        {/* 제목 및 설명 */}
        <div
          className="Frame1000004714"
          style={{
            width: isMobile ? "90%" : "262px",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            gap: 4,
            display: "inline-flex",
          }}
        >
          <div
            className="Frame1000004713"
            style={{
              width: isMobile ? "100%" : "229px",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              display: "flex",
            }}
          >
            <div
              className="Frame1000004712"
              style={{
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 4,
                display: "inline-flex",
                flexWrap: isMobile ? "wrap" : "nowrap",
              }}
            >
              <div
                style={{
                  width: isMobile ? "auto" : "121px",
                  color: "#F57C00",
                  fontSize: isMobile ? 28 : 32,
                  fontFamily: "SB Aggro",
                  fontWeight: "400",
                  lineHeight: isMobile ? "40px" : "48px",
                  wordWrap: "break-word",
                }}
              >
                루틴케어
              </div>
              <div
                style={{
                  width: isMobile ? "auto" : "31px",
                  color: "#404040",
                  fontSize: isMobile ? 20 : 24,
                  fontFamily: "SB Aggro",
                  fontWeight: "400",
                  lineHeight: isMobile ? "30px" : "36px",
                  wordWrap: "break-word",
                }}
              >
                에{" "}
              </div>
            </div>
            <div
              style={{
                alignSelf: "stretch",
                color: "#404040",
                fontSize: isMobile ? 20 : 24,
                fontFamily: "SB Aggro",
                fontWeight: "400",
                lineHeight: isMobile ? "30px" : "36px",
                wordWrap: "break-word",
              }}
            >
              오신 것을 환영해요!
            </div>
          </div>
          <div
            style={{
              alignSelf: "stretch",
              color: "#A3A3A3",
              fontSize: isMobile ? 14 : 16,
              fontFamily: "Pretendard",
              fontWeight: "500",
              lineHeight: isMobile ? "20px" : "24px",
              wordWrap: "break-word",
            }}
          >
            간편 가입으로 건강 습관을 시작해보세요.
          </div>
        </div>
        {/* 로그인 버튼들 */}
        <div
          className="Frame427319054"
          style={{
            width: "100%",
            left: "0",
            // top: "50%",
            bottom: "0",
            position: "absolute",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 12,
            display: "inline-flex",
          }}
        >
          {/* 카카오 로그인 */}
          <button
            onClick={handleKakaoLogin}
            className="KakaoIdLogin"
            style={{
              alignSelf: "stretch",
              paddingTop: 12,
              paddingBottom: 12,
              background: "#FEE500",
              borderRadius: 8,
              justifyContent: "center",
              alignItems: "center",
              gap: 12,
              display: "inline-flex",
              border: "none",
              cursor: "pointer",
            }}
          >
            <div className="IconContainer" style={{ position: "relative" }}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12.0006 1C5.98197 1 0.5 5.07604 0.5 10.1043C0.5 13.2307 2.49089 15.9872 5.52322 17.6272L4.24793 22.4028C4.1342 22.8249 4.60573 23.1623 4.96736 22.9174L10.5605 19.1344C11.032 19.1813 11.5125 19.2087 12.0006 19.2087C18.3515 19.2087 23.5 15.1313 23.5 10.1043C23.5 5.07604 18.3515 1 12.0006 1Z"
                  fill="black"
                  fillOpacity="0.902"
                />
              </svg>
            </div>
            <div
              className="ButtonText"
              style={{
                width: isMobile ? "auto" : "116px",
                color: "#262626",
                fontSize: isMobile ? 14 : 16,
                fontFamily: "Pretendard",
                fontWeight: "500",
                wordWrap: "break-word",
              }}
            >
              카카오로 시작하기
            </div>
          </button>

          {/* 네이버 로그인 */}
          <button
            onClick={handleNaverLogin}
            className="NaverIdLogin"
            style={{
              alignSelf: "stretch",
              paddingTop: 12,
              paddingBottom: 12,
              background: "#03C75A",
              borderRadius: 8,
              justifyContent: "center",
              alignItems: "center",
              gap: 12,
              display: "inline-flex",
              border: "none",
              cursor: "pointer",
            }}
          >
            <div className="IconContainer" style={{ position: "relative" }}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5702 12.7L8.14876 2H2V22H8.44628V11.3L15.8512 22H22V2H15.5702V12.7Z"
                  fill="white"
                />
              </svg>
            </div>
            <div
              className="ButtonText"
              style={{
                width: isMobile ? "auto" : "116px",
                color: "white",
                fontSize: isMobile ? 14 : 16,
                fontFamily: "Pretendard",
                fontWeight: "500",
                wordWrap: "break-word",
              }}
            >
              네이버로 시작하기
            </div>
          </button>

          {/* 게스트 로그인 */}
          {/* <button
            onClick={handleGuestLogin}
            className="GuestIdLogin"
            style={{
              alignSelf: "stretch",
              paddingTop: 12,
              paddingBottom: 12,
              background: "#cacaca",
              borderRadius: 8,
              justifyContent: "center",
              alignItems: "center",
              gap: 12,
              display: "inline-flex",
              border: "none",
              cursor: "pointer",
            }}
          >
            <div className="IconContainer" style={{ position: "relative" }}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 640 640"
                fill="#7f7f7f"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M320 312C386.3 312 440 258.3 440 192C440 125.7 386.3 72 320 72C253.7 72 200 125.7 200 192C200 258.3 253.7 312 320 312zM290.3 368C191.8 368 112 447.8 112 546.3C112 562.7 125.3 576 141.7 576L498.3 576C514.7 576 528 562.7 528 546.3C528 447.8 448.2 368 349.7 368L290.3 368z" />
              </svg>
            </div>
            <div
              className="ButtonText"
              style={{
                width: isMobile ? "auto" : "116px",
                color: "white",
                fontSize: isMobile ? 14 : 16,
                fontFamily: "Pretendard",
                fontWeight: "500",
                wordWrap: "break-word",
              }}
            >
              GUEST LOGIN
            </div>
          </button> */}

          {/* <div
            className="Frame427319060"
            style={{
              alignSelf: "stretch",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: 12,
              display: "flex",
            }}
          > */}
          {/* Apple 로그인 */}
          <button
            onClick={handleAppleLogin}
            className="AppleIdLogin"
            style={{
              alignSelf: "stretch",
              paddingTop: 12,
              paddingBottom: 12,
              background: "#050708",
              borderRadius: 8,
              justifyContent: "center",
              alignItems: "center",
              gap: 12,
              display: "inline-flex",
              border: "none",
              cursor: "pointer",
            }}
          >
            <div className="AppleIcon" style={{ position: "relative" }}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.2808 18.424C20.933 19.2275 20.5213 19.9672 20.0442 20.6472C19.394 21.5743 18.8616 22.216 18.4513 22.5724C17.8153 23.1573 17.1338 23.4568 16.4041 23.4739C15.8802 23.4739 15.2485 23.3248 14.513 23.0224C13.7752 22.7214 13.0972 22.5724 12.4772 22.5724C11.827 22.5724 11.1296 22.7214 10.3837 23.0224C9.63662 23.3248 9.03481 23.4824 8.57468 23.498C7.87491 23.5278 7.1774 23.2197 6.48118 22.5724C6.03681 22.1848 5.48099 21.5204 4.81515 20.5791C4.10075 19.5739 3.51342 18.4084 3.05329 17.0795C2.56051 15.6442 2.31348 14.2543 2.31348 12.9087C2.31348 11.3673 2.64654 10.0379 3.31366 8.92385C3.83796 8.029 4.53546 7.32312 5.40844 6.80493C6.28142 6.28674 7.22468 6.02267 8.24048 6.00578C8.7963 6.00578 9.52518 6.1777 10.431 6.51559C11.3342 6.85462 11.9141 7.02655 12.1684 7.02655C12.3585 7.02655 13.0028 6.82552 14.0949 6.42473C15.1278 6.05305 15.9995 5.89916 16.7136 5.95978C18.6487 6.11595 20.1024 6.87876 21.0693 8.25303C19.3386 9.30163 18.4826 10.7703 18.4996 12.6544C18.5152 14.122 19.0476 15.3432 20.0939 16.3129C20.5681 16.7629 21.0977 17.1107 21.6868 17.3578C21.5591 17.7283 21.4242 18.0832 21.2808 18.424ZM16.8428 0.960131C16.8428 2.11039 16.4226 3.18439 15.5849 4.17847C14.5741 5.36023 13.3514 6.04311 12.0256 5.93536C12.0087 5.79736 11.9989 5.65213 11.9989 5.49951C11.9989 4.39526 12.4796 3.21349 13.3333 2.24724C13.7595 1.75801 14.3015 1.35122 14.9588 1.02671C15.6147 0.707053 16.2352 0.530273 16.8187 0.5C16.8357 0.653772 16.8428 0.807554 16.8428 0.960116V0.960131Z"
                  fill="white"
                />
              </svg>
            </div>
            <div
              className="ButtonText"
              style={{
                width: isMobile ? "auto" : "116px",
                color: "white",
                fontSize: isMobile ? 14 : 16,
                fontFamily: "Pretendard",
                fontWeight: "500",
                wordWrap: "break-word",
              }}
            >
              Apple로 시작하기
            </div>
          </button>

          {/* 구글 로그인 */}
          {/* <button
              onClick={handleGoogleLogin}
              className="GoogleIdLogin"
              style={{
                width: "100%",
                paddingTop: 12,
                paddingBottom: 12,
                background: "white",
                borderRadius: 8,
                outline: "1px #D4D4D4 solid",
                outlineOffset: "-1px",
                justifyContent: "center",
                alignItems: "center",
                gap: 12,
                display: "inline-flex",
                border: "none",
                cursor: "pointer",
              }}
            >
              <div
                className="Frame427319102"
                style={{ width: 24, height: 24, position: "relative" }}
              >
                <div
                  className="IconGoogle"
                  style={{ left: 1.5, top: 1, position: "absolute" }}
                >
                  <svg
                    width="23"
                    height="22"
                    viewBox="0 0 23 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M22.06 11.25C22.06 10.47 21.99 9.72 21.86 9H11.5V13.255H17.42C17.165 14.63 16.39 15.795 15.225 16.575V19.335H18.78C20.86 17.42 22.06 14.6 22.06 11.25Z"
                      fill="#4285F4"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M11.4999 21.9998C14.4699 21.9998 16.9599 21.0148 18.7799 19.3348L15.2249 16.5748C14.2399 17.2348 12.9799 17.6248 11.4999 17.6248C8.63492 17.6248 6.20992 15.6898 5.34492 13.0898H1.66992V15.9398C3.47992 19.5348 7.19992 21.9998 11.4999 21.9998Z"
                      fill="#34A853"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5.345 13.0896C5.125 12.4296 5 11.7246 5 10.9996C5 10.2746 5.125 9.56957 5.345 8.90957V6.05957H1.67C0.925 7.54457 0.5 9.22457 0.5 10.9996C0.5 12.7746 0.925 14.4546 1.67 15.9396L5.345 13.0896Z"
                      fill="#FBBC05"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M11.4999 4.375C13.1149 4.375 14.5649 4.93 15.7049 6.02L18.8599 2.865C16.9549 1.09 14.4649 0 11.4999 0C7.19992 0 3.47992 2.465 1.66992 6.06L5.34492 8.91C6.20992 6.31 8.63492 4.375 11.4999 4.375Z"
                      fill="#EA4335"
                    />
                  </svg>
                </div>
              </div>
              <div
                className="ButtonText"
                style={{
                  width: isMobile ? "auto" : "116px",
                  color: "#404040",
                  fontSize: isMobile ? 14 : 16,
                  fontFamily: "Pretendard",
                  fontWeight: "500",
                  wordWrap: "break-word",
                }}
              >
                구글로 시작하기
              </div>
            </button> */}
          {/* </div> */}

          {/* 이메일 로그인 */}
          <button
            onClick={() => navi("/auth/login/normal")}
            className="Frame5930"
            style={{
              width: isMobile ? "100%" : "320px",
              paddingLeft: 32,
              paddingRight: 32,
              paddingTop: 8,
              paddingBottom: 8,
              borderRadius: 8,
              justifyContent: "center",
              alignItems: "center",
              gap: 10,
              display: "inline-flex",
              background: "transparent",
              border: "none",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                color: "#262626",
                fontSize: 16,
                fontWeight: "500",
                lineHeight: "24px",
                letterSpacing: "-0.32px",
                textDecoration: "underline",
              }}
            >
              일반 로그인
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};
